module.exports = __webpack_public_path__ + "static/media/modulo-gestao-servico.eb5c0b90.svg";